import * as types from "./mutation-types";
import Vue from "vue";
const vm = new Vue();
import EventBus from "../../../shared/utils/event_bus";

export default {
  // +------------------------------------------------------------------------------+
  // | ALTERNAR MINICARD                                                            |
  // +------------------------------------------------------------------------------+
  [types.SET_VISUALIZATION_MODE](state, payload) {
    state.visualizationMode = payload;
  },

  async [types.INIT_TOPIC](state, topics) {
    state.webSocket = await new vm.$websocket.ConsumeTopic(topics);
  },

  [types.ADD_TOPIC](state, topics) {
    state.topics = topics;
  },

  [types.STOP_TOPIC](state) {
    if (state.webSocket != null) {
      state.webSocket.stop();
      state.webSocket = null;
    }
  },

  [types.SEND_MESSAGE](state, payload) {
    let { user_code } = payload.selectedAccount;
  },

  // +------------------------------------------------------------------------------+
  // | APAGAR MÁSCARA DO ESTADO                                                     |
  // +------------------------------------------------------------------------------+
  [types.UPDATE_INVESTMENT](state, payload) {
    // substitui item por um novo objeto
    state.investment.splice(payload.index, 1, Object.freeze(payload.data));
  },

  // +------------------------------------------------------------------------------+
  // | LISTAGEM DOS INVESTIMENTOS AO INICIAR                                        |
  // +------------------------------------------------------------------------------+
  [types.GET_INVESTMENT](state, payload) {
    const { investments, events } = payload;

    state.investment = investments.map((item) => {
      if (item.masks_list) {
        return {
          ...item,
          open_pnl: 0,
          masks_list: item.masks_list.map((item) => {
            return {
              type: item,
              fixedMask: true,
              result: null,
            };
          }),
        };
      } else {
        return {
          ...item,
          open_pnl: 0,
        };
      }
    });
    // state.investment = investments.map((item) => Object.freeze(item));
  },

  // +------------------------------------------------------------------------------+
  // | OBTER CONFIGURAÇÕES DE PARÂMETROS                                            |
  // +------------------------------------------------------------------------------+
  [types.GET_PARAMETER_SETTINGS](state, payload) {
    state.parameters.parameterSettings = payload;
    state.parameters.selectedParameter = payload.filter((item) => item.selected == true)[0];
  },

  // +------------------------------------------------------------------------------+
  // | ATUALIZAR INVESTIMENTO POR 'INVESTMENT_ID'                                   |
  // +------------------------------------------------------------------------------+
  [types.UPDATE_BY_INVESTMENT_ID](state, payload) {
    state.investment.splice(payload.index, 1, Object.freeze(payload.data));
    return;
  },

  // +------------------------------------------------------------------------------+
  // | ATUALIZAR INVESTIMENTO MARKETDATA                                   |
  // +------------------------------------------------------------------------------+
  [types.UPDATE_BY_MARKETDATA](state, payload) {
    state.investment.splice(payload.index, 1, Object.freeze(payload.data));

    return;
  },

  // +------------------------------------------------------------------------------+
  // | ATUALIZA O INVESTIMENTO QUANDO RECEBE O EVENTO DE SNAPSHOT                   |
  // +------------------------------------------------------------------------------+
  [types.UPDATE_BY_INVESTMENT_ID_SNAPSHOT_EVENT](state, payload) {
    // PRODUCTION
    if (state.investment.length > 0) {
      state.investment.splice(payload.index, 1, Object.freeze(payload.data));
      return;
    }
  },

  // +------------------------------------------------------------------------------+
  // | FECHA A POSIÇÃO E LIMPA O CARD DE INVESTIMENTO                               |
  // +------------------------------------------------------------------------------+
  [types.CLEAN_INVESTMENT_BY_INVESTMENT_ID](state, payload) {
    // PRODUCTION
    if (state.investment.length > 0) {
      state.investment.splice(payload.index, 1, Object.freeze(payload.data));
      return;
    }
  },

  // +------------------------------------------------------------------------------+
  // | ATUALIZA OS DADOS DE PREÇO MÉDIO, STOP LOSS E GAIN                           |
  // +------------------------------------------------------------------------------+
  [types.UPDATE_BY_INVESTMENT_ID_UPDATE_POSITION_EVENT](state, payload) {
    if (state.investment.length > 0) {
      state.investment.splice(payload.index, 1, Object.freeze(payload.data));
      return;
    }
    // end PRODUCTION
  },

  // +------------------------------------------------------------------------------+
  // | ATINGIU A META DE GANHO                                                      |
  // +------------------------------------------------------------------------------+
  [types.UPDATE_STRATEGY_GAIN](state, payload) {
    // PRODUCTION
    if (state.investment.length > 0) {
      payload.forEach((gain) => state.investment.splice(gain.index, 1, Object.freeze(gain.data)));
      return;
    }
    // end PRODUCTION
  },

  // +------------------------------------------------------------------------------+
  // | ATINGIU O LIMITE DE PERDA                                                      |
  // +------------------------------------------------------------------------------+
  [types.UPDATE_STRATEGY_LOSS](state, payload) {
    // PRODUCTION
    if (state.investment.length > 0) {
      payload.forEach((loss) => state.investment.splice(loss.index, 1, Object.freeze(loss.data)));
      return;
    }
    // end PRODUCTION
  },

  // +------------------------------------------------------------------------------+
  // | O INVESTIMENTO PAROU DE OPERAR                                               |
  // +------------------------------------------------------------------------------+
  [types.UPDATE_STRATEGY_TIME](state, payload) {
    // PRODUCTION
    if (state.investment.length > 0) {
      payload.forEach((time) => state.investment.splice(time.index, 1, Object.freeze(time.data)));
      return;
    }
    // end PRODUCTION
  },

  // -------------------------------------------------------------------------------
  [types.LIST_PARAMS](state, payload) {
    state.parameters.parameterSettings = payload;
    state.parameters.selectedParameter = payload.filter((x) => x.selected == true)[0];
  },

  [types.SELECTED_PARAM](state, payload) {
    state.parameters.selectedParameter = payload;
  },

  [types.GET_PARAM_INFO](state, payload) {
    state.parameters.section_index = 0;
    state.parameters.info = JSON.parse(JSON.stringify(payload));
    state.parameters.copy_info = JSON.parse(JSON.stringify(payload));
  },

  [types.SECTION_INDEX](state, payload) {
    state.parameters.section_index = payload;
  },

  [types.SEARCH_INVESTMENT](state, payload) {
    state.adjustments.search = payload;
  },

  [types.ORDER_INVESTMENT](state, payload) {
    if (payload.type == "asc") {
      state.adjustments.order.asc = true;
      state.adjustments.order.desc = false;
      state.adjustments.order.position_asc = false;
      state.adjustments.order.position_desc = false;
      state.adjustments.order.max_profit = false;
      state.adjustments.order.min_profit = false;
    } else if (payload.type == "desc") {
      state.adjustments.order.desc = true;
      state.adjustments.order.asc = false;
      state.adjustments.order.position_asc = false;
      state.adjustments.order.position_desc = false;
      state.adjustments.order.max_profit = false;
      state.adjustments.order.min_profit = false;
    } else if (payload.type == "max_profit") {
      state.adjustments.order.desc = false;
      state.adjustments.order.asc = false;
      state.adjustments.order.position_asc = false;
      state.adjustments.order.position_desc = false;
      state.adjustments.order.max_profit = true;
      state.adjustments.order.min_profit = false;
    } else if (payload.type == "min_profit") {
      state.adjustments.order.desc = false;
      state.adjustments.order.asc = false;
      state.adjustments.order.position_asc = false;
      state.adjustments.order.position_desc = false;
      state.adjustments.order.max_profit = false;
      state.adjustments.order.min_profit = true;
    } else if (payload.type == "position_asc") {
      state.adjustments.order.position_asc = true;
      state.adjustments.order.position_desc = false;
      state.adjustments.order.max_profit = false;
      state.adjustments.order.desc = false;
      state.adjustments.order.asc = false;
    } else if (payload.type == "position_desc") {
      state.adjustments.order.position_desc = true;
      state.adjustments.order.position_asc = false;
      state.adjustments.order.max_profit = false;
      state.adjustments.order.min_profit = false;
      state.adjustments.order.desc = false;
      state.adjustments.order.asc = false;
    }
  },

  [types.FILTERS_INVESTMENT](state, payload) {
    if (payload == "Posicionado") {
      state.adjustments.filters.push("Vendido", "Comprado", "BUY", "SELL");
    } else {
      state.adjustments.filters.push(payload);
    }
  },

  [types.REMOVER_FILTERS_INVESTMENT](state, payload) {
    if (payload == "remover-all") {
      state.adjustments.filters = [];
    } else if (payload == "Posicionado") {
      state.adjustments.filters = state.adjustments.filters.filter(
        (x) => x != "Vendido" && x != "Comprado" && x != "BUY" && x != "SELL"
      );
    } else {
      state.adjustments.filters = state.adjustments.filters.filter((x) => x != payload);
    }
  },

  [types.SELECTED_PARAMS_INVESTMENT](state, payload) {
    state.selectedParameter = payload;
  },

  [types.SET_INVESTMENT_VOLUME](state, { investment_id, volume }) {
    const index = state.investment.findIndex((item) => item.investment_id === investment_id);
    state.investment[index].curr_volume = volume;
  },

  [types.SET_INVESTMENT_VOLUME_TYPE](state, { investment_id, volume_type }) {
    const index = state.investment.findIndex((item) => item.investment_id === investment_id);
    state.investment[index].volume_type = volume_type;
  },

  [types.SET_INVESTMENT_VOLUME_BY_TYPE](state, { investment_id, volume }) {
    const index = state.investment.findIndex((item) => item.investment_id === investment_id);
    const types = {
      FIN_VOLUME: "financialVolume",
      QUANTITY: "quantityVolume",
    };
    const selectedInvestment = state.investment[index];
    const selectedType = types[selectedInvestment.volume_type];
    selectedInvestment[selectedType] = volume;
  },

  [types.SET_INVESTMENT_SYMBOL_PRICE](state, { symbol, last_price }) {
    const investments = state.investment.filter(
      (item) => item.status === "RUNNING" && item.strategy_market === "Equities" && item.strategy_symbol === symbol
    );
    for (const investment of investments) {
      investment.last_price = last_price;
    }
  },

  [types.SET_GAIN_LOSS](state, { running_data, stopped_data }) {
    const loop = (array) => {
      for (const item of array) {
        const index = state.investment.findIndex((elem) => elem.investment_id === item.investment_id);
        state.investment.splice(index, 1, {
          ...state.investment[index],
          max_gain: item.limit_values.MAX_GAIN,
          max_loss: item.limit_values.MAX_LOSS,
          limit_type: item.limit_values.LIMIT_TYPE,
          qtd_volume: item.limit_values.qtd_volume,
          fin_volume: item.limit_values.fin_volume,
        });
      }
    };
    if (running_data) {
      loop(running_data);
    }
    if (stopped_data) {
      loop(stopped_data);
    }
  },

  [types.SET_PARAM_BY_ID](state, payload) {
    let params = state.parameters.info.param_params;
    const objLoop = (obj, id, newValue) => {
      for (let key in obj) {
        let value = obj[key];
        if (typeof value === "object") {
          objLoop(value, id, newValue);
        } else if (value === id) {
          obj.param_value = newValue;
        }
      }
    };
    objLoop(params, payload.id, payload.value);
  },

  [types.SET_SAVE_IS_ENABLED](state, payload) {
    state.saveParameterIsEnabled = payload;
  },

  [types.SET_RANGE_FILTER](state, { slug, value }) {
    let index = state.filters.findIndex((item) => item.slug === slug);
    state.filters[index].value = value;
  },

  [types.SET_STRING_FILTER](state, { slug, value }) {
    let index = state.filters.findIndex((item) => item.slug === slug);
    state.filters[index].value = value;
  },

  [types.SET_TOGGLE_FILTER](state, { slug, value }) {
    let index = state.filters.findIndex((item) => item.slug === slug);
    let filter = state.filters[index];
    if (filter.active.includes(value)) {
      filter.active.splice(
        filter.active.findIndex((item) => item === value),
        1
      );
      return;
    }
    filter.active.push(value);
  },

  [types.SET_SEARCH_CHARS](state, payload) {
    let index = state.filters.findIndex((item) => item.slug === "Caracteres");
    state.filters[index].value = payload.length ? payload.toUpperCase() : payload;
  },

  [types.INVESTMENT_CLEAR_ACTIVE_FILTERS](state) {
    state.filters.forEach((item) => {
      if (item.hasOwnProperty("active")) {
        item.active = [];
      }
      if (item.hasOwnProperty("value") && item.type === "range") {
        item.value = item.initialValue;
      }
      if (item.hasOwnProperty("value") && item.type === "string") {
        item.value = "";
      }
    });
    EventBus.$emit("MARKETPLACE_CLEAR_ACTIVE_FILTERS");
  },
};
